import { render, staticRenderFns } from "./reading-widget.vue?vue&type=template&id=404224c5&"
import script from "./reading-widget.vue?vue&type=script&lang=js&"
export * from "./reading-widget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports